/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const Youtube24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="YouTube 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M9.988 14.586V8.974c1.993.938 3.536 1.843 5.36 2.82-1.505.834-3.367 1.77-5.36 2.792Zm11.103-8.403c-.344-.452-.93-.805-1.553-.922-1.833-.348-13.267-.349-15.099 0-.5.094-.945.32-1.328.673C1.5 7.43 2.005 15.452 2.393 16.75c.164.563.375.968.64 1.234.343.353.812.595 1.351.704 1.51.312 9.284.486 15.122.046a2.62 2.62 0 0 0 1.39-.71c1.49-1.49 1.388-9.963.195-11.842Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Youtube24,
  md: Youtube24,
  lg: Youtube24,
  xl: Youtube24,
  xxl: Youtube24,
  xxxl: Youtube24,
};

export const YoutubeIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'youtube-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
